module.exports = __webpack_public_path__ + "fc282e1892a4c4b1227bf1091e3e922f.png";